import { useEffect } from 'react';
import { isWeb } from '../../constants';
const MESSAGE_NAME = 'google-oauth2-success';
export function makeWebRedirectUri() {
    const search = new URLSearchParams({ eventName: MESSAGE_NAME });
    // see linking in useAppLink.ts
    const u = new URL('/auth-complete', window.location.origin);
    u.search = search.toString();
    return u.toString();
}
export function useListenToPopupMessage(callback) {
    useEffect(() => {
        if (isWeb) {
            const listener = (event) => {
                if (event.data === MESSAGE_NAME) {
                    callback();
                }
            };
            window.addEventListener?.('message', listener);
            return () => window.removeEventListener?.('message', listener);
        }
        return undefined;
    }, [callback]);
}
export function openPopup(url) {
    if (!isWeb)
        return;
    const width = 500;
    const height = 600;
    let left = 0;
    let top = 0;
    if (window.screenX != null && window.outerWidth != null)
        left = window.screenX + (window.outerWidth - width) / 2;
    if (window.screenY != null && window.outerHeight != null)
        top = window.screenY + (window.outerHeight - height) / 2.5;
    const options = `width=${width},height=${height},left=${left},top=${top}`;
    window.open?.(url, 'google-login', options);
}
